import {
  CommonIncidentId,
  RugbyUnionIncidentId,
} from '@collector/sportsapi-client-legacy'

import { HistoryFiltersConfig } from '../../../configuration'
import { historyFiltersAttributesConfig } from './historyFiltersAttributesConfig'
import { incidentIdsGroup } from './incidentsGroup'

export const historyFiltersConfig: HistoryFiltersConfig = {
  withConfirmation: true,
  historyFiltersAttributes: historyFiltersAttributesConfig,
  historyFiltersIncidents: [
    RugbyUnionIncidentId.Try,
    RugbyUnionIncidentId.PenaltyTry,
    RugbyUnionIncidentId.ConversionGoal,
    RugbyUnionIncidentId.ConversionMissed,
    RugbyUnionIncidentId.ConversionAttempt,
    RugbyUnionIncidentId.PenaltyKickGoal,
    RugbyUnionIncidentId.PenaltyKickMissed,
    RugbyUnionIncidentId.PenaltyAwarded,
    RugbyUnionIncidentId.FreeKick,
    RugbyUnionIncidentId.DropGoal,
    RugbyUnionIncidentId.DropGoalMissed,
    RugbyUnionIncidentId.YellowCard,
    RugbyUnionIncidentId.RedCard,
    RugbyUnionIncidentId.OrangeCard,
    incidentIdsGroup,
    RugbyUnionIncidentId.Ruck,
    RugbyUnionIncidentId.Scrum,
    RugbyUnionIncidentId.Lineout,
    RugbyUnionIncidentId.Kick,
    RugbyUnionIncidentId.GoallineDropout,
    RugbyUnionIncidentId.EntryInto22,
    RugbyUnionIncidentId.Offload,
    RugbyUnionIncidentId.Turnover,
    RugbyUnionIncidentId.Foul,
    RugbyUnionIncidentId.Tackle,
    RugbyUnionIncidentId.Injury,
    RugbyUnionIncidentId.InPossession,
    RugbyUnionIncidentId.Timeout,
    CommonIncidentId.TechnicalProblems,
    RugbyUnionIncidentId.RefereeReview,
    RugbyUnionIncidentId.Kickoff,
    RugbyUnionIncidentId.MedicalTimeout,
    RugbyUnionIncidentId.BreakDuringGame,
    RugbyUnionIncidentId.WaterBreak,
  ],
}
